import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { ServicesListWrapper } from './services-list/ServicesList'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'

const servicesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Service Management',
    path: '/admin/pages/services',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/services/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const ServicesPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='services'
          index
          element={
            <>
              <PageTitle breadcrumbs={servicesBreadcrumbs}>Services list</PageTitle>
              <ServicesListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/services/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/services' />} />
    </Routes>
  )
}

export default ServicesPage
